import { EndpointCallParams } from '@core/api/endpointCallParams';

import { IApiStore } from '@core/api/apiStore';

export type GetGradingsParam = {
  executionIds?: string[],
  actorIds?: string[],
  IsReviewed?: boolean,
  minScore?: number,
  maxScore?: number,
  minReviewedScore?: number,
  maxReviewedScore?: number,
  from?: Date,
  to?: Date,
};

export type AddGradingParams = {
  gradingData: any,
}
export type AddReviewParams = {
  gradingId?: string,
  reviewData: any,
}

export const postGradings = async (api: IApiStore, params: EndpointCallParams<AddGradingParams>) => {
    const { payload, ...rest } = params;
    const gradingData = payload
    const req = api
        .post('neoanalytics-app/api/v1/gradings?isReviewed=true', {
            ...rest,
            payload: {
                ...gradingData,
            },
        })

    return req;
}

export const addReview = async (api: IApiStore, params: EndpointCallParams<AddReviewParams>) => {
    const { payload, ...rest } = params;
    const gradingData = payload.reviewData;
    const req = api
        .post(`neoanalytics-app/api/v1/gradings/${payload.gradingId}/reviews`, {
            ...rest,
            payload: {
                ...gradingData,
            },
        })

    return req;
}
